module.exports = __webpack_public_path__ + "img/F977.2562f2af.jpg";